import React, { useState, useEffect, useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { Grid } from "antd";
import "../style.css";
import _ from "lodash";
import { MetaMaskContext } from "./MetaMaskSDKContainer";

import Header from "./Header";
import Footer from "./Footer";

const { useBreakpoint } = Grid;

const AppLayout = (props) => {
  const { children, backgroundColor = "transparent" } = props;
  const breakpoint = useBreakpoint();

  const [showDrawer, setShowDrawer] = useState(false);

  return (
    <div className="App">
      <Header showDrawer={showDrawer} setShowDrawer={setShowDrawer} />
      <div
        className="scrollbarContainer"
        style={{
          height: breakpoint?.md
            ? "calc(100vh - 96px - 64px)"
            : "calc(100vh - 80px - 64px)",
          overflowY: "auto",
          overflowX: "hidden",
          backgroundColor
        }}
      >
        {children}
      </div>

      <Footer />
    </div>
  );
};

export default AppLayout;
